import { render } from "./OrgaoAetImg.vue?vue&type=template&id=5bebe5ed&scoped=true"
import script from "./OrgaoAetImg.vue?vue&type=script&lang=ts"
export * from "./OrgaoAetImg.vue?vue&type=script&lang=ts"

import "./OrgaoAetImg.vue?vue&type=style&index=0&id=5bebe5ed&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5bebe5ed"

export default script